import React, { Fragment } from "react";
import _ from "lodash";
import {Formik } from 'formik';
import {compose} from 'redux';
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import {Dialog, DialogTitle, Grid, DialogContent} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import TextInput from 'components/Global/FormikMaterial/TextInput';
import CheckboxSelectListInput from 'components/Global/FormikMaterial/CheckboxSelectListInput';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import { UnstyledDateField } from "components/Global/Fields/Date";

const DateFieldWrapper = styled.div`
 & div:first-child {
   width: 170px;
 }
 & label {
  font-size:17px;
}
 &&&&& div div::before {
   border-bottom: 1px solid #2196F3;
 }
`;
const Block = styled.div`
  display:block;
  margin: 16px 0;
`;
const styles = () => ({
  dialogPaper: {
    'max-width':'600px',
    'font-size': '13px',        
  },
  dialogTitle: {
    color: 'blue',
    padding: '0 0 0 20px'
  },
  formLabelRoot: {
    
    marginTop: '30px',
    marginLeft: '5px',
  },
  checkboxRoot: {
    marginLeft: '20px',
    height: '32px'
  },
});

class Reminder extends React.Component {
  onCancel = () => {
    this.props.onClose();
  };

  closeModal = () => {
    this.props.onClose();  
  };

  errorHandlingSubmit = (errors, handleSubmit) => {
    // Just for April 2019 demo. Normally the modal will only close afte a successful submit.
    this.closeModal();

    if(_.isEmpty(errors))
      handleSubmit();
  };
  
  render() {
    let { isOpen, classes, reminder, sendToOptions } = this.props;        
    return (
      <Fragment>        
        <Dialog open={isOpen} onClose={this.closeModal} fullWidth maxWidth="md" classes={{paper: classes.dialogPaper}}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between">
            <DialogTitle classes={{root: classes.dialogTitle}}>Reminder</DialogTitle>
            <IconButton style={{ marginRight: 16, marginTop:5 }} onClick={this.closeModal}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>            
          </Grid>

        <DialogContent>
        <Formik
          initialValues={reminder}
          validateOnChange={false}
          validate={values => {                
            let errors ={}
            return errors;
          }}
          onSubmit={(values, {setSubmitting}) => {                            
            setSubmitting(false);
          }}
          render={({values, errors, status, touched, isSubmitting, handleChange, handleBlur, handleSubmit}) => (                  
            <Fragment>
              <Block>
                <DateFieldWrapper>
                  <UnstyledDateField />
                </DateFieldWrapper>
              </Block>
                <Block>
                  <TextInput fullWidth label="Message" fieldName="message"/>
                </Block>
                <Block>
                  <CheckboxSelectListInput
                    classes={classes}
                    label="Send to"
                    fieldName="sendTo"
                    options={sendToOptions}
                      />
                </Block>
              <Grid container direction="row" justify="flex-end">
                <SecondaryButton onClick={this.onCancel}>Cancel</SecondaryButton>                    
                <PrimaryButton onClick={() => this.errorHandlingSubmit(errors, handleSubmit)}>Save</PrimaryButton>
              </Grid>
            </Fragment>
            )}/>        
        </DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}




export default compose(

  withStyles(styles)
)(Reminder);
